(() => {
  'use strict';

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const overlay = $('[data-overlay]');
  const body = document.body;
  let returnFocus = null;
  let toastTimer;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[character]);

  const formatMoney = (cents) => {
    const currency = window.Shopify && Shopify.currency ? Shopify.currency.active : '';
    const locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, currency ? { style: 'currency', currency } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cents) / 100);
    } catch (error) {
      return `${(Number(cents) / 100).toFixed(2)} ${currency}`.trim();
    }
  };

  const showToast = (message) => {
    const toast = $('[data-toast]');
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  const panels = ['[data-mobile-nav]', '[data-search-overlay]', '[data-cart-drawer]'];
  const closePanels = (restoreFocus = true) => {
    panels.forEach((selector) => {
      const panel = $(selector);
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    $$('[aria-expanded="true"]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (overlay) overlay.classList.remove('is-active');
    body.classList.remove('is-locked');
    if (restoreFocus && returnFocus) returnFocus.focus();
    returnFocus = null;
  };

  const openPanel = (panel, trigger) => {
    if (!panel) return;
    closePanels(false);
    returnFocus = trigger || document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-active');
    body.classList.add('is-locked');
    window.setTimeout(() => {
      const focusTarget = $('button, input, select, a[href]', panel);
      if (focusTarget) focusTarget.focus();
    }, 280);
  };

  const mobileNav = $('[data-mobile-nav]');
  const searchOverlay = $('[data-search-overlay]');
  const cartDrawer = $('[data-cart-drawer]');
  const mobileOpen = $('[data-mobile-nav-open]');
  const searchOpen = $('[data-search-open]');
  const cartOpen = $('[data-cart-open]');

  if (mobileOpen) mobileOpen.addEventListener('click', () => openPanel(mobileNav, mobileOpen));
  if (searchOpen) searchOpen.addEventListener('click', () => openPanel(searchOverlay, searchOpen));
  if (cartOpen) cartOpen.addEventListener('click', () => openPanel(cartDrawer, cartOpen));
  $$('[data-mobile-nav-close], [data-search-close], [data-cart-close]').forEach((button) => button.addEventListener('click', () => closePanels()));
  if (overlay) overlay.addEventListener('click', () => {
    const facets = $('[data-facets]');
    if (facets) facets.classList.remove('is-open');
    closePanels();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

  const header = $('[data-site-header]');
  if (header) {
    const setHeaderState = () => header.classList.toggle('is-scrolled', window.scrollY > 45);
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  $$('[data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  const renderCart = (cart) => {
    if (!cartDrawer) return;
    const content = $('[data-cart-content]', cartDrawer);
    const footer = $('[data-cart-footer]', cartDrawer);
    const count = $('[data-cart-count]');
    if (count) {
      count.textContent = cart.item_count;
      count.classList.toggle('is-empty', cart.item_count === 0);
    }

    if (cart.item_count === 0) {
      content.innerHTML = `<div class="cart-empty"><span class="cart-empty__icon">0</span><h3>Your bag is empty</h3><p>Find the pair built for your pitch.</p><a class="button button--primary" href="${escapeHtml(window.cleatsZone.routes.allProducts)}">Continue shopping</a></div>`;
      if (footer) footer.classList.add('is-hidden');
      return;
    }

    content.innerHTML = `<div class="cart-drawer__items">${cart.items.map((item) => `
      <article class="cart-line" data-cart-line data-key="${escapeHtml(item.key)}">
        <a class="cart-line__image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}${item.image.includes('?') ? '&' : '?'}width=240" width="120" height="120" loading="lazy" alt="${escapeHtml(item.product_title)}">` : ''}</a>
        <div class="cart-line__info">
          <a class="cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-line__variant">${escapeHtml(item.variant_title)}</span>` : ''}
          <span class="cart-line__price">${formatMoney(item.final_line_price)}</span>
          <div class="quantity-control quantity-control--small">
            <button type="button" aria-label="Decrease quantity" data-cart-quantity="${Math.max(0, item.quantity - 1)}"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14" stroke="currentColor" stroke-width="1.8"/></svg></button>
            <span>${item.quantity}</span>
            <button type="button" aria-label="Increase quantity" data-cart-quantity="${item.quantity + 1}"><svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8"/></svg></button>
          </div>
          <button class="text-button" type="button" data-cart-remove>Remove</button>
        </div>
      </article>`).join('')}</div>`;

    if (footer) {
      footer.classList.remove('is-hidden');
      const total = $('[data-cart-total]', footer);
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.cleatsZone.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const changeCartLine = async (key, quantity) => {
    const response = await fetch(`${window.cleatsZone.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || window.cleatsZone.strings.error);
    renderCart(cart);
  };

  if (cartDrawer) cartDrawer.addEventListener('click', async (event) => {
    const line = event.target.closest('[data-cart-line]');
    if (!line) return;
    const quantityButton = event.target.closest('[data-cart-quantity]');
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!quantityButton && !removeButton) return;
    const target = quantityButton || removeButton;
    target.disabled = true;
    try {
      await changeCartLine(line.dataset.key, removeButton ? 0 : Number(quantityButton.dataset.cartQuantity));
    } catch (error) {
      target.disabled = false;
      showToast(error.message || window.cleatsZone.strings.error);
    }
  });

  $$('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = $('[data-add-to-cart]', form);
    if (!button || button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch(`${window.cleatsZone.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || window.cleatsZone.strings.error);
      const cart = await fetchCart();
      renderCart(cart);
      openPanel(cartDrawer, button);
      showToast(window.cleatsZone.strings.added);
    } catch (error) {
      showToast(error.message || window.cleatsZone.strings.error);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }));

  $$('[data-product-root]').forEach((root) => {
    const variantsElement = $('[data-product-variants]', root);
    const variants = variantsElement ? JSON.parse(variantsElement.textContent) : [];
    const optionGroups = $$('[data-option-position]', root);
    const variantInput = $('[data-variant-id]', root);
    const price = $('[data-product-price]', root);
    const comparePrice = $('[data-product-compare-price]', root);
    const addButton = $('[data-add-to-cart]', root);
    const addLabel = $('[data-add-label]', root);
    const addPrice = $('[data-add-price]', root);

    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      const thumb = $(`[data-gallery-thumb="${mediaId}"]`, root);
      if (thumb) thumb.click();
    };

    const updateVariant = () => {
      const selectedOptions = optionGroups.map((group) => {
        const checked = $('input:checked', group);
        const selectedLabel = $('[data-selected-option]', group);
        if (selectedLabel && checked) selectedLabel.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = window.cleatsZone.strings.unavailable;
        if (addPrice) addPrice.textContent = '';
        return;
      }
      variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        comparePrice.classList.toggle('is-hidden', !(variant.compare_at_price > variant.price));
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? window.cleatsZone.strings.addToCart : window.cleatsZone.strings.soldOut;
      if (addPrice) addPrice.textContent = variant.available ? `— ${formatMoney(variant.price)}` : '';
      if (variant.featured_media) activateMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    optionGroups.forEach((group) => group.addEventListener('change', updateVariant));

    const quantity = $('[data-quantity-input]', root);
    const minus = $('[data-quantity-minus]', root);
    const plus = $('[data-quantity-plus]', root);
    if (minus && quantity) minus.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    if (plus && quantity) plus.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });

    $$('[data-gallery-thumb]', root).forEach((thumb) => thumb.addEventListener('click', () => {
      $$('[data-gallery-thumb]', root).forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-selected', 'false'); });
      $$('.product-gallery__slide', root).forEach((slide) => slide.classList.remove('is-active'));
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');
      const slide = $(`[data-media-id="${thumb.dataset.galleryThumb}"]`, root);
      if (slide) slide.classList.add('is-active');
      const current = $('[data-gallery-current]', root);
      if (current) current.textContent = thumb.dataset.galleryIndex;
    }));
  });

  $$('product-recommendations').forEach(async (element) => {
    if (!element.dataset.url || element.innerHTML.trim()) return;
    try {
      const response = await fetch(element.dataset.url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('product-recommendations');
      if (recommendations && recommendations.innerHTML.trim()) {
        element.innerHTML = recommendations.innerHTML;
        $$('.reveal', element).forEach((item) => item.classList.add('is-visible'));
      }
    } catch (error) {
      // Recommendations are optional; keep the section hidden if the request fails.
    }
  });

  $$('[data-auto-submit]').forEach((control) => control.addEventListener('change', () => control.form.requestSubmit()));
  const filterToggle = $('[data-filter-toggle]');
  const filterClose = $('[data-filter-close]');
  const facets = $('[data-facets]');
  if (filterToggle && facets) filterToggle.addEventListener('click', () => {
    facets.classList.add('is-open');
    facets.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    body.classList.add('is-locked');
  });
  if (filterClose && facets) filterClose.addEventListener('click', () => {
    facets.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    body.classList.remove('is-locked');
  });

  const revealItems = $$('.reveal');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }), { rootMargin: '0px 0px -5% 0px', threshold: 0.08 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
})();
